import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import axios from "axios";
import "./weather.css";

export default function Weather(props) {
    const [weather, setWeather] = useState({ ready: false });
    const [city, setCity] = useState(props.defaultCity);

    function handleResponse(response) {
        setWeather({
            ready: true,
            temperature: response.data.temperature.current,
            wind: response.data.wind.speed,
            humidity: response.data.temperature.humidity,
            description: response.data.condition.description,
            icon: response.data.condition.icon, 
            dateDay: new Date(response.data.time * 1000),
            city: response.data.city,
        });
        }

    function search() {
        const apiKey = "d102f34aao5ce8t34e64ea7aab7a37d2";
        let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    
        axios.get(apiUrl).then(handleResponse);

    }

    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    function handleCityChange(event) {
        setCity(event.target.value);
        
    }

    if (weather.ready) {
        return (
        <div className="Weather">
            <form onSubmit={handleSubmit}>
                <input type="search" placeholder="Enter a city.." className="Search" onChange={handleCityChange}/>
                <input type="submit" value="Search" className="btn btn-primary Submit" />
            </form>
            <WeatherInfo data={weather} />
            <WeatherForecast data={weather}/>
            </div>
        );  
    } else {
        search();
        return "Loading..";
    }

} 